import type { ReactNode } from 'react';
import { Icon } from '../icons';
import { BuildStamp } from './build-stamp';
import { useHeaderActions } from './header-actions';
import s from './patient-shell.module.css';

/**
 * The patient header. The route to the care navigator is on every patient screen (PAT-02).
 */
export function PatientTop({
  name,
  initials,
  helpLabel,
  onHelp,
  onSignOut,
}: {
  name: string;
  initials: string;
  helpLabel: string;
  onHelp: () => void;
  onSignOut?: () => void;
}) {
  const actions = useHeaderActions();
  return (
    <header className={s.ptop}>
      <div className={s.in}>
        <span className={s.brand}>Concord</span>
        <span className={s.cen}>Cancer Expert Now</span>
        <div className={s.me}>
          <span>{name}</span>
          <span className={s.av}>{initials}</span>
          {onSignOut && (
            <button type="button" onClick={onSignOut}>
              Sign out
            </button>
          )}
        </div>
        {actions}
        <button type="button" className={s.help} onClick={onHelp} aria-label={helpLabel}>
          <Icon.Chat />
          <span className={s.helpText}>{helpLabel}</span>
        </button>
      </div>
    </header>
  );
}

export function PatientPage({ children }: { children: ReactNode }) {
  return (
    <div className={s.pwrap}>
      {children}
      <BuildStamp />
    </div>
  );
}

export function PatientHead({ title, lead }: { title: ReactNode; lead?: ReactNode }) {
  return (
    <div className={s.ph}>
      <h1>{title}</h1>
      {lead && <p>{lead}</p>}
    </div>
  );
}

export { s as patientShellStyles };
